import { Box } from "@mui/material";
import { DotLegalAlert, DotLegalDialog } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";

interface PromoteMitigationDialogProps {
    count: number;
    hasDriftedPlan: boolean;
    inProgress: boolean;
    onClose: () => void;
    onSubmit: () => void;
}

// Promotion realizes the plan's after-mitigation risk as the new current risk and moves the plan to its
// terminal Promoted state. It is irreversible, so it is gated behind this confirmation; the count covers
// both the single per-row action and the bulk action. A drifted plan is warn-but-allow: its expected target
// was set against an outdated rating, so promoting realizes a stale target — flagged but not blocked.
function PromoteMitigationDialog({ count, hasDriftedPlan, inProgress, onClose, onSubmit }: PromoteMitigationDialogProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalDialog
            open
            header={translateString("riskMitigationPromoteConfirmTitle")}
            buttonOkText={`${translateString("promote")} (${count})`}
            onDialogClose={onClose}
            onOkClick={onSubmit}
            inProgress={inProgress}
            size={"sm"}
        >
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <DotLegalAlert severity={"warning"} warningText={translateString("riskMitigationPromoteConfirmText")} />
                {hasDriftedPlan && <DotLegalAlert severity={"warning"} warningText={translateString("riskMitigationPromoteDriftWarning")} />}
            </Box>
        </DotLegalDialog>
    );
}

export default PromoteMitigationDialog;
